module.exports = __webpack_public_path__ + "static/media/location.191f3a69.svg";